// extracted by mini-css-extract-plugin
export default {"wrapper":"input-expand_wrapper__A6NZb","label":"input-expand_label__JNMNU","length":"input-expand_length__uvhY1"};